import React from 'react';
import { Button, Grid } from 'ui-toolkit/index';
import { ISideSheetFormFooterProps } from './SideSheetFormFooter';
import { useFormikContext } from 'formik';

interface IEditContactFormSideSheetFooterProps extends ISideSheetFormFooterProps {
  showWarning: () => void;
}

export const SideSheetEditContactFormFooter: React.FC<IEditContactFormSideSheetFooterProps> = ({
  onCancel,
  saveButtonText,
  showWarning,
}) => {
  const { dirty, isValid } = useFormikContext();
  const isDisabled = !isValid || !dirty;
  return (
    <Grid columnCount={1}>
      <Button intent="primary" type="submit" disabled={isDisabled}>
        {saveButtonText}
      </Button>
      <Grid columnCount={2}>
        <Button intent="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button intent="danger" type="button" onClick={showWarning}>
          Delete Contact
        </Button>
      </Grid>
    </Grid>
  );
};
